import { normalizeStoryMap, type WorldDocument } from '@private-fiction/story-core';

/** Derived from canonical files on each decision; never a second location store. */
export function mapDiscoveryContext(documents: readonly WorldDocument[], activeIds: readonly string[]): string {
  const live = documents.filter(doc => !doc.deletedAt);
  const active = new Set(activeIds);
  for (const doc of live) if (active.has(doc.id)) {
    for (const ref of doc.references) if (['current_location', 'located_at'].includes(ref.relation)) active.add(ref.targetId);
  }
  const maps = live.filter(doc => doc.kind === 'story_map').map(doc => ({ doc, map: normalizeStoryMap(doc.fields, doc.storyId) }));
  const candidates = live.filter(doc => doc.kind === 'location' && (active.has(doc.id) || doc.visibility === 'pinned'));
  const rows = candidates.slice(0, 12).map(location => ({
    fileId: location.id, title: location.title.slice(0, 120), revision: location.revision,
    mapped: maps.flatMap(({ doc, map }) => map.anchors.filter(anchor => anchor.locationDocumentId === location.id).slice(0, 4).map(anchor => ({
      mapId: doc.id, anchorId: anchor.id, layerId: anchor.layerId,
      ...(anchor.targetMapId ? { targetMapId: anchor.targetMapId, targetExists: maps.some(target => target.doc.id === anchor.targetMapId || target.map.id === anchor.targetMapId) } : {}),
    }))).slice(0, 4),
  }));
  // IDs/titles are data, not instructions; do not truncate JSON into invalid fragments.
  while (rows.length && JSON.stringify(rows).length > 4000) rows.pop();
  return JSON.stringify({ locations: rows, omitted: candidates.length - rows.length });
}
